import React from 'react';
import { CalendarDaysIcon, DollarSignIcon, ClockIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1173">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1174">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1175">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1176">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1177">
              <CalendarDaysIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1178" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1179">
              Check Calendar
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1180">
              Check FLSC Club Calendar for class dates for either CPL Class or
              CPL Renewal.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1181">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1182">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1183" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1184">
              From $35
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1185">
              Members: $35 · Non-Members: $60
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1186">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1187">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1188" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1189">
              3+ Hours
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1190">
              Minimum 3 hours course review plus 1 hour live fire range time.
            </p>
          </div>
        </div>
      </div>
    </div>;
}